// extracted by mini-css-extract-plugin
module.exports = {"formButtons":"ChangePasswordModal_formButtons__1P0gV","formChangePassword":"ChangePasswordModal_formChangePassword__1jnlV"};